//
//
//
//
//
//
//
//
//
//
//

import Heading from '@/components/Heading'

export default {
  components: {
    Heading
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },

  computed: {
    tabs() {
      let path = `/services/${this.$route.params.id}`
      return [
        { to: `${path}/overview`, label: 'Overview', icon: 'border_all' },
        { to: `${path}/health`, label: 'Health', icon: 'favorite_border' },
        {
          to: `${path}/tickets`,
          label: 'Tickets',
          icon: 'o_confirmation_number'
        },
        // { to: `${path}/equipment`, label: 'Equipment', icon: 'construction' },
        { to: `${path}/location`, label: 'Location', icon: 'o_place' }
        // { to: `${path}/management`, label: 'Management', icon: 'o_settings' }
      ]
    }
  }
}
